import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tete } from './Tete.js';
/**
 * Document complet. Le moteur possède `<html>` et `<head>` ; le thème ne
 * fournit que le contenu de `<body>`. Un thème sur mesure hérite donc
 * gratuitement des `hreflang`, du canonical et du JSON-LD.
 */
export function Document({ ctx, meta, theme }) {
    const Corps = theme.Corps;
    return (_jsxs("html", { lang: ctx.langue, children: [_jsx(Tete, { ctx: ctx, meta: meta, theme: theme }), _jsx("body", { className: theme.classeCorps?.(ctx.vue), children: _jsx(Corps, { ctx: ctx }) })] }));
}
//# sourceMappingURL=Document.js.map